// @ts-nocheck
import { alpha, createTheme } from '@mui/material';
import _ from 'lodash';
import baseTheme from './base';
// The palette enables you to modify the color of the components to suit your brand.
// https://material-ui.com/customization/palette/
// https://material-ui.com/customization/default-theme/?expand-path=$.palette
export default createTheme(
  _.merge(baseTheme, {
    themeName: 'SAMS Light',

    palette: {
      type: 'light',
      common: {
        black: '#000',
        white: '#fff',
        blue: '#174a84',
        green: '#0bb7a7',
        red: '#FF2400',
        orange: '#FFBF00',
        yellow: '#ffcc00',
        darkGreen: '#00cc44',
        lightcyan: '#cff7f2',
        lightgreen: '#5acfc4',
        lightBlue: '#f2f8fc',
        lightergreen: '#f5fcfb',
        lightgray: '#F5F5F5',
        lightgray2: '#00000061',
        lightBlue1: '#1890ff',
        lightgray1: '#878787',
        lightgray3: '#00000014',
        lightgray4: '#f9f9f9',
        borderColor: '#ddd',
      },
      primary: {
        light: '#5acfc4',
        main: '#0bb7a7',
        dark: '#0bb7a7',
        contrastText: '#fff',
        fade: '#5acfc41A',
      },
      secondary: {
        light: '#e33371',
        main: '#dc004e',
        // dark: will be calculated from palette.secondary.main,
      },
      error: {
        lighter: '#FFE7D9',
        light: '#FFA48D',
        main: '#FF4842',
        dark: '#B72136',
        darker: '#7A0C2E',
        contrastText: '#fff',
      },
      mainDetailsCard: {
        primary: '#CFF7F2',
        secondary: '',
      },
      muiSlider: {
        primary: '#FFA500',
        secondary: '',
      },
      analystCard: {
        primary: '#bddad7',
      },
      descriptionCard: {
        primary: '#FCF0E5',
        secondary: '#ADD8E6',
      },
      text: {
        primary: '#000',
      },
      calendar: {
        field: {
          background: '#FFFFFF',
          text: '#565656',
          icon: '#8F8F8F',
          stroke: '#E9E9E9',
          shadow: '0px 1px 2px 0px #0F172A0F',
        },
        dateAndTimeSelector: {
          text: '#393939', // Use for Date, Time, Month and Year.
          days: '#565656',
          background: '#FFFFFF',
          icon: '#8F8F8F',
          divider: '#E9E9E9',
          timeSelectionBackground: '#0C3270',
          DateSelectionBackground: '#E9EBFD',
        },
      },
      /* specify custom components style here Eg: <MyComponent /> */
      myComponent: {
        login: {
          bgColor: '#e5e5e5',
        },
      },
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: '#fff',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            backgroundColor: '#0bb7a7',
            color: '#fff',
            fontWeight: 600,
          },
          stickyHeader: {
            backgroundColor: '#0bb7a7',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          outlined: {
            borderColor: '#0bb7a7',
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            backgroundColor: '#0bb7a7',
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: '#353935',
          },
        },
      },
      MuiDayCalendar: {
        styleOverrides: {
          weekDayLabel: ({ theme }) => ({
            color: theme?.palette?.calendar?.dateAndTimeSelector?.days,
          }),
          // Custom slot used by DateRangeCalendarWrapper
          dayContainer: ({
            theme,
            day,
            isSelectionComplete,
            hoveredDay,
            range,
          }) => {
            const startDate = range?.start;
            const endDate = range?.end;
            const isStartSelectedButNotEnd = Boolean(startDate && !endDate);
            const isMomentDateSame = (a, b) =>
              a?.format('DD-MM-YYYY') === b?.format('DD-MM-YYYY');
            const isStartOrEnd =
              isMomentDateSame(day, startDate) ||
              isMomentDateSame(day, endDate);
            const borderColor = alpha(
              theme?.palette?.calendar?.dateAndTimeSelector
                ?.timeSelectionBackground,
              0.5
            );
            return {
              border: '2px dashed transparent',
              borderRadius: '50%',
              transition: 'all 200ms',
              willChange: 'border, border-color, border-radius',
              // normal hover over day
              ':hover .MuiPickersDay-root': {
                border: '2px solid',
                borderColor:
                  theme?.palette?.calendar?.dateAndTimeSelector
                    ?.timeSelectionBackground,
                backgroundColor: isStartOrEnd
                  ? theme?.palette?.calendar?.dateAndTimeSelector
                      ?.timeSelectionBackground
                  : theme?.palette?.calendar?.dateAndTimeSelector
                      ?.DateSelectionBackground,
              },
              // styles on hover, does not apply to fillers on calendar
              '&:has(:not(.MuiPickersDay-hiddenDaySpacingFiller)):hover': {
                ...(isStartSelectedButNotEnd &&
                  day?.isAfter(startDate) && {
                    borderColor,
                  }),
                // highlighting on the hovered day, when start selected but not end
                ...(isStartSelectedButNotEnd &&
                  isMomentDateSame(day, hoveredDay) &&
                  day?.isAfter(startDate) && {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderLeftColor: 'transparent',
                    borderTopColor: borderColor,
                    borderBottomColor: borderColor,
                    borderRightColor: borderColor,
                  }),
                // when start and hovered day are same
                ...(isStartSelectedButNotEnd &&
                  isMomentDateSame(startDate, hoveredDay) && {
                    borderRadius: '50%',
                  }),
              },
              // styles applied when selection is complete
              ...(isSelectionComplete && {
                // for days in between start and end
                ...(day.isBetween(startDate, endDate, undefined, '()') && {
                  backgroundColor:
                    theme?.palette?.calendar?.dateAndTimeSelector
                      ?.DateSelectionBackground,
                  borderRadius: 0,
                }),
                // for start day
                ...(isMomentDateSame(day, startDate) && {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderTopLeftRadius: '50%',
                  borderBottomLeftRadius: '50%',
                  backgroundColor:
                    theme?.palette?.calendar?.dateAndTimeSelector
                      ?.DateSelectionBackground,
                }),
                // for end day
                ...(isMomentDateSame(day, endDate) && {
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderTopRightRadius: '50%',
                  borderBottomRightRadius: '50%',
                  backgroundColor:
                    theme?.palette?.calendar?.dateAndTimeSelector
                      ?.DateSelectionBackground,
                }),
              }),
              // styles applied when selection is in progress
              ...(isStartSelectedButNotEnd && {
                // for days between start and hovered day, exclusive
                ...(day?.isBetween(startDate, hoveredDay, undefined, '()') && {
                  borderLeftColor: 'transparent',
                  borderRightColor: 'transparent',
                  borderTopColor: borderColor,
                  borderBottomColor: borderColor,
                  borderRadius: 0,
                }),
                // for start day
                ...(isMomentDateSame(day, startDate) && {
                  borderRadius: 0,
                  borderTopLeftRadius: '50%',
                  borderBottomLeftRadius: '50%',
                  borderRightColor: 'transparent',
                  borderLeftColor: borderColor,
                  borderTopColor: borderColor,
                  borderBottomColor: borderColor,
                }),
              }),
            };
          },
        },
      },
      SolyticsDateCalendar: {
        styleOverrides: {
          root: ({ theme }) => ({
            border: '1px solid',
            borderColor: theme?.palette?.calendar?.field?.stroke,
            borderRadius: theme?.spacing(1),
          }),
        },
      },
      SolyticsTimeRangeCalendar: {
        styleOverrides: {
          root: {
            display: 'flex',
            flexDirection: 'row',
          },
        },
      },
      // Custom component defined in `src/components/WrapperComponents`
      SolyticsDateRangePicker: {
        styleOverrides: {
          root: ({ theme }) => ({
            flexDirection: 'row',
            gap: theme?.spacing(2),
            width: '100%',
          }),
          detailedSeparator: ({ hasLabel }) => {
            return {
              position: 'absolute',
              top: hasLabel ? 'calc(6px + 19.6px + 10px)' : '50%',
              left: '50%',
              transform: `translate(-50%, ${hasLabel ? 0 : '-50%'})`,
            };
          },
          hiddenSeparator: {
            visibility: 'hidden',
          },
        },
      },
      SolyticsDateTimeRangeCalendar: {
        styleOverrides: {
          root: ({ theme }) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            border: '1px solid',
            borderColor: theme?.palette?.calendar?.field?.stroke,
            borderRadius: theme?.spacing(1),
            width: 'fit-content',
          }),
          dateCalendar: {
            border: 'none',
          },
          digitalClock: {
            border: 'none',
          },
          content: {
            display: 'flex',
            flexDirection: 'row',
          },
          actions: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
          },
        },
      },
      SolyticsDateTimeRangeSingleInput: {
        styleOverrides: {
          root: {
            alignItems: 'center',
            padding: '0 14px',
            gap: '10px',
            width: '100%',
            '.MuiIconButton-root': {
              padding: 0,
            },
          },
          input: {
            border: 'none',
            outline: 'none',
            fontFamily: 'Montserrat',
            minWidth: '50px',
            flexGrow: 1,
          },
          separator: {
            display: 'flex',
            alignSelf: 'center',
          },
        },
      },
    },
  })
);
